import { FC, useContext } from 'react';

import { Messages, RichText } from '@marriott/mi-ui-library';

import { PageContext } from '../../../modules/context/PageContext';

type WalletSectionUxlErrorProps = {
  className?: string;
};

export const WalletSectionUxlError: FC<WalletSectionUxlErrorProps> = ({ className }) => {
  const pageContext = useContext(PageContext);

  return (
    <div className={className} data-testid="wallet-section-uxl-error">
      <Messages messageType="warning" className="my-4">
        <RichText text={pageContext?.uxlErrorMessage} componentId="uxl-error-msg" />
      </Messages>
    </div>
  );
};
